import loader from '../moduleLoader';
import animateScrollTo from 'animated-scroll-to';

class StickyNav {
    constructor(nav) {
        this.nav = nav;
        this.handleAlignment = this.handleAlignment.bind(this);
        this.obseve = this.observe.bind(this);
        this.handleSticky = this.handleSticky.bind(this);
        this.items = null;
        this.scrollDirection = null;
    }
    init() {
        this.items = this.nav.querySelectorAll('.premise-nav__anchor');
        if (this.items.length === 0) {
            this.items = this.nav.querySelectorAll('.sticky-nav__anchor');
        }
        if (!this.items) return;

        if (window.location.pathname.includes('fastigheter')) {
            this.items[1].parentElement.remove()
            this.items = Array.from(this.items).filter( (item) =>
                !item.attributes[0].value.includes("#myiframe")
            );
        }
        Array.from(this.items).forEach(item => {
            item.addEventListener('click', this.handleItemClick);
        });
        window.addEventListener('resize', this.handleAlignment);
        this.handleAlignment();
        this.observe();
        this.handleSticky();
        let that = this;
        window.onscroll = function (e) {
            if (this.oldScroll > this.scrollY) {
                that.scrollDirection = 'up';
            }
            else {
                that.scrollDirection = 'down';
            };
            this.oldScroll = this.scrollY;
        }
    }
    handleSticky() {

        if (!document.querySelector('main > .hero:first-child')) return;
        const nav = this.nav;
        let observer = new IntersectionObserver(function (entries, self) {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    nav.classList.add('sticky-nav--fixed')
                }
                else {
                    nav.classList.remove('sticky-nav--fixed')
                }
            })
        }, {
            rootMargin: '-72px 0px 0px 0px',
        })

        observer.observe(document.querySelector('main > .hero:first-child'));

    }
    observe() {
        const config = {
            rootMargin: '0px 0px -85% 0px'
        };

        let observer = new IntersectionObserver(function (entries, self) {
            entries.forEach((entry) => {
                const allItems = this.nav.querySelectorAll('a');
                let navItem = this.nav.querySelector(`[href="#${entry.target.id}"]`);
                if (entry.isIntersecting) {
                    Array.from(this.items).forEach(item => {
                        item.classList.remove('sticky-nav__anchor--active');
                    });
                    navItem.classList.add('sticky-nav__anchor--active');
                }
                else {
                    if (navItem === allItems[0] && this.scrollDirection === 'up') {
                        navItem.classList.remove('sticky-nav__anchor--active');
                    }
                }
            });
        }.bind(this), config);

        Array.from(this.items).forEach((item) => {
            const href = item.getAttribute('href');
            if (href.startsWith('#')) {
                observer.observe(document.getElementById(href.substring(href.length, 1)));
            }
        });
    }
    handleAlignment(e) {
        var nav = this.nav.querySelector('ul');
        if (!nav) {
            return;
        }
        const navWidth = nav.offsetWidth;
        const windowWidth = window.innerWidth;

        if (navWidth >= windowWidth) {
            this.nav.classList.add('sticky-nav--aligned');
        }
        else {
            this.nav.classList.remove('sticky-nav--aligned');
        }
    }
    handleItemClick(e) {
        if (this.href.includes('#')) {
            e.preventDefault();
            const id = this.href.substring(this.href.indexOf('#') + 1);
            var element = document.getElementById(id);
            if (element) {
                animateScrollTo(element.offsetTop - 100);
                history.replaceState(null, '', this.href);
            }
        }
    }
}

loader.add('StickyNav', StickyNav);
export default StickyNav;